export default "__VITE_ASSET__34iG9zYS__"